enum PendingTrayFileStatus {
  Processing = 'Processing',
  Done = 'Done',
}

export default PendingTrayFileStatus;
